import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import instance, { apiEncryptRequest, decryptData } from "../../Api";
import { useAuth } from "../../AuthContext";
import Loader from "../common/Loader";
import { useNavigate } from "react-router-dom";
import AppToast from "../../AppToast";
import toast, { Toaster } from "react-hot-toast";
import { FaCopy } from "react-icons/fa";

const SettingsPage = (props) => {
  const { smuser } = useAuth();

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(isMobileDevice());
  const [isHovered, setIsHovered] = useState(false);
  const [is2faStatus, set2FAStatus] = useState(0);
  const [showSsoPopup, setShowSsoPopup] = useState(false);
  const [generatedSsoUrl, setGeneratedSsoUrl] = useState("");

  function isMobileDevice() {
    return window.matchMedia("(max-width: 800px)").matches;
  }
  useEffect(() => {
    function handleResize() {
      setIsMobile(isMobileDevice());
    }
    set2FAStatus(smuser["2fa_status"]);
    // console.log(smuser["2fa_status"], "smuser");

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile, is2faStatus]);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const StatusChange = async () => {
    setLoading(true);

    const payload = {
      user_id: smuser.id,
      status: is2faStatus === 1 ? 0 : 1,
    };
    try {
      const encryptedResponse = await apiEncryptRequest(payload);
      const loginUserResponse = await instance.post(
        "/statuschange",
        encryptedResponse
      );
      const loginResponse = await decryptData(loginUserResponse.data);
      // console.log(loginResponse, "statusRes");

      if (loginResponse.success) {
        toast((t) => (
          <AppToast
            id={t.id}
            message={loginResponse.message}
            isMobile={isMobile}
          />
        ));

        setTimeout(() => {
          window.location.reload();
        }, 2000);
      } else {
        toast((t) => (
          <AppToast
            id={t.id}
            message={loginResponse.message}
            isMobile={isMobile}
          />
        ));
      }
    } catch (error) {
      console.error("Error during the login process:", error);
      toast((t) => <AppToast id={t.id} message={error} />);
    }
    setLoading(false);
  };

   const handleGenerateSso = async () => {
      try {
        const res = await instance.post("/generate-sso-link", {
          user_id: smuser.id,
        });
  
        if (res.data.success) {
           toast((t) => (
            <AppToast
              id={t.id}
              message={'SSO Link Generated Successfully'}
              isMobile={isMobile}
            />
          ));
          setGeneratedSsoUrl(res.data.url);
          setShowSsoPopup(true);
        }
      } catch (err) {
        console.error(err);
        toast((t) => (
            <AppToast
              id={t.id}
              message={'Failed to generate SSO link'}
              isMobile={isMobile}
            />
          ));
      }
    };
    const copySsoUrl = async () => {
      if (!generatedSsoUrl) return;
  
      await navigator.clipboard.writeText(generatedSsoUrl);
      toast((t) => (
        <AppToast
          id={t.id}
          message={'Copied to clipboard'}
          isMobile={isMobile}
        />
      ));
    };

    
  return (
    <div
      style={{
        width: "100%",
        minHeight: isMobile ? "50rem" : "65rem",
        position: "relative",
        backgroundImage: isMobile ? `url(./main-bg.jpg)` : `url(./main-bg.jpg)`,
        backgroundSize: "cover",
        backgroundRepeat: "round",
        backgroundBlendMode: "overlay",
      }}
    >

      {showSsoPopup && (
          <div
            style={{
              position: "absolute",
              top: "20%",
              left: "30%",
              width: "40rem",
              backdropFilter: "blur(20px)",
              borderRadius: "12px",
              border: "2px solid #e97730",
              zIndex: "999999",
              background: "transparent",
              padding: "130px",
              textAlign: "center",
            }}
          >
            <button onClick={() => setShowSsoPopup(false)} style={{ position: "absolute", right: "10px", top: "10px", background: "transparent", border: "none", color: "#e97730", fontSize: "18px" }}
            >
              ✕
            </button>

            <div style={{
                  color: "white",
                  position: "absolute",
                  top: "8rem",
                  left: "50%",
                  width: "80%",
                  transform: "translate(-50%, -50%)",
                  padding: "20px",
                  outline: "4px solid #035189",
                  border: "4px solid #fff",
                  borderColor: "white",
                  borderRadius: "30px",
                  backgroundColor: "#035189",
                  fontWeight: "600",
                }}>
              
              

              <h4>
                SSO Link
              </h4>

              <div style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  value={generatedSsoUrl}
                  readOnly
                  style={{ flex: 1, padding: "10px", borderRadius: "8px" }}
                />

                <button
                  onClick={copySsoUrl}
                  style={{ background: "#e97730", border: "none", padding: "8px 12px", borderRadius: "8px", color: "white" }}
                >
                  <FaCopy />
                </button>
              </div>
            </div>
        </div>
      )}
      <div className="apptoast-align">
        <Toaster
          position={isMobile ? "top-center" : "bottom-right"}
          reverseOrder={false}
        />
      </div>
      {loading && (
        <div className="loading-overlay" style={{ zIndex: "999999999" }}>
          <Loader isLoading={loading} />
        </div>
      )}

      
      {isMobile ? (
        <>
          <div className="heading-dotted-support" style={{ left: "4%" }}>
            Settings <span></span>
          </div>
          <div
            style={{
              justifyItems: "center",
            }}
          >
            

            <div className="stat" style={{ width: "15rem" }}>
              <div className="machine-icon-edit-profile">
                <img src={"/admin/images/admin/13-Profile/user-white.png"} />
              </div>
              <div className="machine-title theme-bg-orange">Child Users</div>
              <div className="mid-portion" />
              <div
                className="machine-subtitle theme-bg-blue"
                style={{ width: "190px", cursor: "pointer" }}
                onClick={() => {
                  navigate("/childuser");
                }}
              >
                View All Users
              </div>
            </div>

            <div className="stat" style={{ width: "10rem" }}>
              <div className="machine-icon-edit-profile">
                <img src={"/admin/images/admin/13-Profile/user-white.png"} />
              </div>
              <div className="machine-title theme-bg-orange">SSO</div>
              <div className="mid-portion" />
                <div
                  className="machine-subtitle theme-bg-blue"
                  style={{ width: "190px", cursor: "pointer" }}onClick={handleGenerateSso}
                >
                  Generate Link
                </div>
            </div>

            <div
              className="stat"
              style={{
                width: "13rem",
              }}
            >
              <div className="machine-icon-edit-profile">
                <img src={"/images/admin/06-View-Stats/switch.svg"} />
              </div>
              <div
                className="machine-title"
                style={{
                  backgroundColor:
                    is2faStatus && is2faStatus === 1 ? "green" : "red",
                }}
              >
                {is2faStatus && is2faStatus === 1 ? "2FA ON" : "2FA OFF"}
              </div>
              <div className="mid-portion" />
              <div
                className="machine-subtitle theme-bg-blue"
                style={{ width: "170px", cursor: "pointer" }}
                onClick={() => StatusChange()}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                {isHovered
                  ? is2faStatus === 1
                    ? "Disable"
                    : "Enable"
                  : is2faStatus === 1
                  ? "Enable"
                  : "Disable"}
              </div>
            </div>

          </div>
        </>
      ) : (
        <>
          <div className="heading-dotted-machine" style={{ marginTop: "50px" , left: "4%"}}>
           Setting<span></span>
          </div>
          <div
            style={{
              display: "grid",
              justifyItems: "center",
              justifyContent: "center",
              marginTop: "-6rem",
            }}
          >
            <Row>
              {/* <div className="col-md-2"></div> */}
              <div className="col-md-12" style={{ marginLeft: "-70%" }}>
                <div className="details-profile-edit">
                  <>
                    <div className="stat" style={{ width: "15rem" }}>
                      <div className="machine-icon-edit-profile">
                        <img
                          src={"/admin/images/admin/13-Profile/user-white.png"}
                        />
                      </div>
                      <div className="machine-title theme-bg-orange">
                        Child Users
                      </div>
                      <div className="mid-portion" />
                      <div
                        className="machine-subtitle theme-bg-blue"
                        style={{ width: "190px", cursor: "pointer" }}
                        onClick={() => {
                          navigate("/childuser");
                        }}
                      >
                        
                        View All User
                      </div>
                    </div>

                    <div className="stat" style={{ width: "10rem" }}>
                      <div className="machine-icon-edit-profile">
                        <img
                          src={"/admin/images/admin/13-Profile/user-white.png"}
                        />
                      </div>
                      <div className="machine-title theme-bg-orange">
                        SSO
                      </div>
                      <div className="mid-portion" />
                      <div
                        className="machine-subtitle theme-bg-blue"
                        style={{ width: "190px", cursor: "pointer" }}
                        onClick={handleGenerateSso}
                      >
                        
                        Generate Link
                      </div>
                    </div>

                    <div
                      className="stat"
                      style={{
                        width: "13rem",
                      }}
                    >
                      <div className="machine-icon-edit-profile">
                        <img src={"/images/admin/06-View-Stats/switch.svg"} />
                      </div>
                      <div
                        className="machine-title"
                        style={{
                          backgroundColor:
                            is2faStatus && is2faStatus === 1 ? "green" : "red",
                        }}
                      >
                        {is2faStatus && is2faStatus === 1
                          ? "2FA ON"
                          : "2FA OFF"}
                      </div>
                      <div className="mid-portion" />
                      <div
                        className="machine-subtitle theme-bg-blue"
                        style={{ width: "170px", cursor: "pointer" }}
                        onClick={() => StatusChange()}
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                      >
                        {isHovered
                          ? is2faStatus === 1
                            ? "Disable"
                            : "Enable"
                          : is2faStatus === 1
                          ? "Enable"
                          : "Disable"}
                      </div>
                    </div>
                  </>
                </div>
              </div>
            </Row>
          </div>
        </>
      )}
    </div>
  );
};

export default SettingsPage;
